const en = {
  Deposit: "Deposit",
  startedAt: "Started at",
  noRollover: "No Rollover",
  completeness: "Completeness",
  clickHere: "Click here",
  doYouHavePromoCode: "Do you have a promotional code?",
  finishedIn: "Finalized in",
  provider: "Provider",
  consolidatedValue: "Valor Consolidado",
  entryId: "Entry ID",
  registrationDate: "Registration Date",
  depositID: "Deposit ID",
  betStatus: {
    Pending: "Pending",
    Lost: "Lost",
    Awarded: "Awarded",
    Cashout: "Cashout"
  },
  idBet: "Bet ID",
  sport: "Sport",
  cancellation: "Cancellation",
  betDate: "Bet Date",
  infoPrizeValue: "Value in awards",
  resultDate: "Result Date",
  numberOfGames: "No. of games",
  multiplier: "Multiplier",
  consultedOn: "Consulted on",
  download: "Download",
  noDataFount: "No data found!",
  loadingData: "Loading data...",
  deposits: "Deposits",
  amountOfDeposits: "Amount of Deposits",
  onlineBalance: "Online Balance",
  cellPhone: "Mobile",
  usersPlurals: "User | Users",
  depositsPlurals: "Deposit | Deposits",
  noQuery: "No query performed",
  lastLogin: "Last login",
  birthday: "Birthday",
  reports: "Reports",
  users: "Users",
  sortBy: "Sort by",
  affiliateCampaign: {
    title: "Campaigns",
    newCampaign: "New Campaign",
    name: "Campaign name",
    numberOfClicks: "Number of clicks",
    betQty: "Bets",
    usersQty: "Users",
    firstDepositQty: "First deposits",
    channel: "Channel",
    activate: "Enable",
    deactivate: "Disable",
    others: "Others",
    socialMedia: "Social media",
    campaignCode: "Campaign code",
    createCampaign: "Create campaign",
    activeCampaigns: "Active campaigns",
    othersInputText: "Provide another social network",
    copyLink: "Copy link",
    goToCampaigns: "Go to campaigns",
    campaignCreatedSuccessfully: "Campaign created successfully!",
  },
  noTitle: "No title",
  gamesSingularPlural: "Games | {count} Game | {count} Games",
  includedGames: "Games included in this campaign",
  roundsQuantityTip:
    "Total number of rounds available for all games included in this campaign.",
  roundsQuantity: "Total Rounds",
  loginExemptPlayer: "Login as exempt player",
  titleDialogBlockUser: "Warning: {idReason} blocked",
  messageDialogBlockUser: {
    securityReason:
      "For security reasons, the {idReason} function has been temporarily blocked.",
    getExplainingWithSupport:
      "Contact our support to resolve questions and take necessary actions.",
    contactSupport: "Contact support",
    reason: "Reason: ",
    messagesTranslate: {
      thirdPartyData:
        "To ensure financial security, we have suspended withdrawals involving third-party data.",
      violationTermsAndConditions:
        "To maintain a fair environment, we suspend accounts and block withdrawals that do not follow our rules and terms of use.",
      maliciousBets:
        "We have suspended withdrawals related to malicious betting to maintain a fair and transparent betting environment.",
      multiAccounts:
        "Suspensions of withdrawal actions occur when multiple accounts are used by the same user/group for undue gains.",
      suspiciousBehavior:
        "For everyone's financial security, we have suspended withdrawals related to suspicious behavior or fraudulent activities.",
      affiliateAccount:
        "This is a partner account, to withdraw your winnings please contact the administration.",
      exemptBetCasino: "Casino Betting Exemption",
      suspiciousActivityDetected: "Suspicious activity detection.",
      abuseOfSystemCrashes: "Abuse of system crashes.",
      gamblerShowingCompulsiveBehavior: "Gamer showing compulsive behavior.",
      playerAttemptingToUseMethodsThatViolate:
        "Player attempting to use methods that violate our policies and terms of use.",
      moduleUnavailableToThePlayer: "Module unavailable to the player.",
    },
  },
  noSportsPromoFound:
    "There are no promotions available for sports at the moment.",
  searchByTitleAndGame: "Search by title or game name",
  ativa: "Active",
  daysRemaining: "days remaining | day remaining | {count} days remaining",
  forYouOpeningTxt: {
    intro:
      "We've got some special deals just for you, all gathered in one place!",
    howToWinFreeSpins: "How to claim your free spins?",
    development: `To join the fun, simply click 'Claim' on the promos that catch your eye the most!<br><br> After that, the spins will be automatically added to your account for you to use exclusively on the selected games from the chosen promo, and they'll be ready to enjoy until their expire date.`,
    conclusion: "Go ahead, make the most of it, and have a blast!",
  },
  gotIt: "Got it!",
  forYou: "For you",
  ativas: "Active",
  sumFirstDeposits: "Sum of first deposits",
  winAmount: "Win amount",
  loadMore: "Load More",
  myPromotionsOpeningTxt:
    "We've separated promotions especially for you, all gathered in one place! <br /><br /> <b>How to win free spins?</b> <br /> To participate, simply click Claim on the promotions that suit you best! <br /><br /> After that, the spins will be automatically credited to your account for exclusive use in the selected games of the chosen promotion, and will have a period to be used until they expire. <br /><br /> Enjoy and have fun!",
  recommended: "Recommended",
  recommendedForYou: "Recommended for you",
  claim: "Claim",
  theaterMode: "Theater Mode",
  qtdDeposits: "Quantity of Deposits",
  registerDate: "Registration Date",
  noDataForthisQuery: "There is no data for this query.",
  notFound: "Not found.",
  gameNotAvailable: "Game not available at the moment.",
  pleaseTryAgainLater: "Please, try again later.",
  cpaValue: "CPA Value",
  firstDeposit: "First Deposit",
  typeOfCPA: "Type of CPA",
  playerId: "Player ID",
  percent: "Percentage",
  fixedCommission: "Fixed Commission",
  valueCpa: "CPA Value",
  redeemTokenTitle: "Redeem Token",
  allowDeactivateCurrentPromo:
    "I am aware that when redeeming my token, the current promotion will be deactivated. And all previous progress will be lost, including bets that are still pending settlement.",
  infoRedeemToken: "Once redeemed, your promotions will appear in the ",
  redeem: "Redeem",
  insertToken: "Insert your token",
  menuRedeemToken: "Redeem <br /> your token",
  redeemToken: "Redeem your token here",
  minPlayersCommissionTip:
    "To have commissioning, you need to reach a minimum of active users.",
  minimum: "Minimum",
  activeUsers: "Active users",
  remainingActivePlayers:
    "You have reached the minimum amount of active users. | {remainingUsers} active user is missing. | {remainingUsers} active users are missing.",
  depositClinPaysConfirmed: "Deposit confirmed.",
  frequentlyAskedQuestions: "Frequently asked questions",
  // clinPays: {
  cardValidDate: "Type the month correctly",
  nameAsShownOnCard: "Name as shown on card",
  userAnotherCard: "Use another card",
  clinPaysFooter:
    "ClinPays - Ensures safer transactions and early detection of fraudulent transactions. It has more than four years of experience in the field, committed to providing you with payment technologies and innovative products with the highest security established by international brands. ClinPays is certified to the PCI DSS (Payment Card Industry Data Security Standard) standard founded by several institutions including Visa and Mastercard. Plus, your business can be free by authenticating each transaction with 3DS 2.0.",
  saveCardText: "Save card details for future deposits",
  securityCode: "Security code",
  cvvTooltipText: "Enter the 3-digit (CVV) code on the back of the card",
  cardValidity: "Validity",
  cardNumber: "Card number",
  nameOfCardHolder: "Name of card holder",
  // },
  seeAllGamesCategory: "+ See all",
  feeValue: "Fee Value",
  searchByGame: "Search by Game",
  noLoadPaymentMethods: "Unable to load payment methods. Try again later.",
  noLoadLicenses: "Unable to load licenses. Please try again later.",
  noLoadPartner: "Unable to load Partners. Please try again later.",
  paymentMethods: "PAYMENT METHODS",
  maximumDepositAmount: "The maximum deposit amount is R$ {value}.",
  minimumDepositAmount: "The minimum deposit amount is R$ {value}.",
  newDeposit: "New Deposit",
  congratsDeposit:
    "Thanks! Now you can enjoy the best of sports entertainment. Place your bets and good Luck!",
  depositConfirmed: "PIX deposit confirmed.",
  pixCopyPaste: "Copy/Paste Pix Code",
  depositPaymentProviderRules: {
    PixPay4Fun:
      "PIX by Pay4Fun does not accept random keys,<br />only keys type <strong>CPF</strong>, <strong>email</strong> or <strong>mobile</strong>.<br />Check your registration.",
    PixPaybrokersBrasilCash:
      "Deposits are made by Pix.<br />It is mandatory to have your <strong>CPF</strong> registered.",
    PixPaguePay:
      "Deposits are made by Pix.<br />It is mandatory to have your <strong>CPF</strong> registered.",
    PixPagFast:
      "Deposits are made by Pix.<br />It is mandatory to have your <strong>CPF</strong> registered.",
  },
  resendEmailTip:
    "Tip: When requesting resend email, always check the last email sent!",
  dateExpiration: "Expiration date",
  walletPay4FunFooter1:
    "Pay4Fun is a 100% virtual, safe and fast wallet to facilitate your transactions on the Internet! And best of all: no cost* for your deposits by Pix, bank transfer, bank slip or credit card. you already have a Pay4Fun account, select the desired amount and click on 'Deposit'. You will be redirected to the Pay4Fun website to complete the transaction and will be forwarded back to",
  walletPay4FunFooter2:
    "automatically when you complete your transaction on Pay4Fun. To open your Pay4Fun account or get more information visit: www.p4f.com or download the App.",
  walletPay4FunFooter2_1: "*in some cases, bank fees apply.",
  depositWalletPay4Fun: "Deposit by Pay4Fun Wallet",
  walletWithdrawalPay4Fun: "Withdrawal to Pay4Fun Wallet",
  minValueDialog: "Min. $",
  maxValueDialog: "Max. $",
  infoValue: "Inform the value",
  bonusConversionConfirmation: "Bonus Conversion Confirmation",
  areYouSureYouWantToConvert: "Are you sure you want to convert",
  ofBonusIn: "of bonus in",
  ofRealBalance: "of real balance",
  toRealBalance: "to real balance",
  walletWithdrawalFooter1:
    "Pay4Fun is a 100% virtual, safe and fast wallet to facilitate your transactions on the Internet! And best of all: no cost* for your deposits via Pix, bank transfer, bank slip or credit card. If you already have a Pay4Fun account, select the desired amount, fill in your Pay4Fun account details and click on 'Withdraw'. You will have to wait for the procedure and confirmation of the withdrawal by the financial department of",
  walletWithdrawalFooter2:
    "After confirmation, the amount withdrawn will be transferred to your Pay4Fun account. To open your Pay4Fun account or get more information visit: www.p4f.com or download the App.",
  walletWithdrawalFooter2_1: "*In some cases, bank fees apply.",
  paybrokersFooter1:
    "Paybrokers offers Payment Facilitation (eFx) services through its modern and secure electronic platform for deposits and withdrawals, facilitating online purchases on international sites.",
  paybrokersFooter2:
    "Paybrokers follows the rules of the Central Bank of Brazil, as well as the best international payment practices.",
  settings: "Settings",
  invalidPixKey: "Invalid PIX key! Only CPF, email or phone.",
  needToRegisterPixKey: "You need to register your PIX key",
  noPaymentMethodsMsg:
    "No payment methods available at the moment. Try again later!",
  depositPixByPayBrokers: "PIX deposit by Paybrokers",
  brazilCashDeposit: "Deposit by Brasil Cash",
  brazilCashWithdraw: "Withdrawal via Brasil Cash",
  depositPixByPay4FunGo: "Deposit by Pay4Fun GO",
  withdrawalByPayBrokers: "Withdrawal via Paybrokers",
  withdrawalByPay4FunGo: "Withdrawal via Pay4Fun GO",
  paagDeposit: "Deposit by Paag",
  paguePayDeposit: "Deposit by Pague Pay",
  pagFastDeposit: "Deposit by PagFast",
  paagWithdraw: "Withdrawal by Paag",
  paguePayWithdraw: "Withdrawal by Pague Pay",
  pagFastWithdraw: "Withdrawal by PagFast",
  paagFooter: `Paag is a company specialized in payment solutions for the
  of iGaming and sports betting. Focused on compliance and fees
  competitive, Paag offers efficient solutions for carrying out
  financial transactions securely.`,
  paguePayFooter:
    "PaguePay offers electronic payment management solutions (eFX) to streamline fund inflows and outflows, making it easier to make purchases on global platforms. We integrate our technology with yours, enabling multiple financial options for your users directly within your application.",
  pagFastFooter: "Pagfast offers electronic payment management (eFX) solutions to facilitate inflows and outflows of funds, making it simpler to make purchases on global platforms. We combine our technology with yours, enabling multiple financial options for your users directly on your application.",
  pay4funWithdrawlFooterText1:
    "Pay4Fun GO is a direct, secure and fast payment, facilitating your transactions on the Internet! And best of all: no cost* for your withdrawals through Pix or bank transfer. Just select the desired amount and click on 'Withdraw' . You will be redirected to complete the transaction. You will have to wait for the procedure and confirmation of the withdrawal by the financial department of ",
  pay4funWithdrawlFooterText2:
    "After confirmation, the amount withdrawn will be deposited in your bank account. *In some cases, bank fees apply.",
  pay4funDepositFooterText1:
    "Pay4Fun GO is a direct, secure and fast payment, facilitating your transactions on the Internet! And best of all: no cost* for your deposits through Pix, bank transfer. Just select the desired amount and click on 'Deposit' . You will be redirected to complete the transaction. As soon as you complete the payment in the chosen way, it will be automatically released on ",
  pay4funDepositFooterText2:
    "*In some cases, bank fees apply. **Release time varies depending on the payment method chosen.",
  cashoutAvailable: "Cashout Available",
  eventNumber: "Number of Events",
  useBonus: "Use Bonus",
  bankVerificationIntroductionText:
    "The bank verification checks if the registered pix key matches one of the Banks authorized by our system.",
  pixEditBlocked:
    "The edit of bank data is blocked, please contact support to update your data.",
  //   bankVerificationIntroductionText:
  //     "The bank verification checks if the registered pix key matches one of the Banks authorized by our system.",
  bankVerificationHowDoesItWorkText: "How does it work?",
  bankVerificationText:
    "We will make a withdrawal of BRL 1.00 (One Real) to validate if your pix key belongs to one of the authorized Banks. If successful, the user will be able to withdraw normally. make withdrawals, until you change your Financial Data and indicate a pix key that belongs to one of the Banks authorized by our system.",
  notRegistered: "Not Registered",
  profileBankVerificationDenied:
    "Verification denied. Check for errors in the pix key informed and/or if the registered bank is among those accepted by our system.",
  successVerification: "Verification successful!",
  bankVerified: "Bank verified",
  pendingVerification: "Pending bank verification.",
  processingVerification: "Processing verification",
  verificationDenied: "Verification Denied, please try again.",
  maybeYouNeedChangeYourData: "You may need to change your bank details",
  bankVerificationTitle: "Bank Verification",
  bankVerificationLearnMore:
    "The bank verification checks if the registered pix key matches the bank. The User cannot withdraw until the verification is completed. If successful, the user will be able to withdraw normally. If it is denied, the user will be prevented from making withdrawals, until they change their financial data and indicate a new bank that is in the list of available banks in our system.",
  verifyBank: "Check",
  goToProfile: "go to Profile",
  learnMore: "Learn more",
  bankVerificationPending: "Bank verification is required to make withdrawals!",
  bankVerificationProcessing:
    "Processing bank verification. Wait a few moments.",
  bankVerificationDenied:
    "The bank verification was denied. Go to 'Profile' and change the Financial Data",
  searchYourBank: "Search the bank of your pix key",
  showBalance: "Show balance",
  hideBalance: "Hide balance",
  refreshBalance: "Update balance",
  confirmByEmail: "Confirm by email",
  affiliateCode: "Affiliation Code (Optional)",
  msgFavoritesLimit: "You have reached the maximum number of favorites",
  finished: "Finished",
  finishedPlural: "Finished",
  favorites: "Favorites",
  noDataFound: "No data found",
  minus: "minus",
  report: "Report",
  accountDisabled: "Account Disabled",
  disabledByLoginAttempts: "Blocked for exceeded login attempts",
  totalAffiliates: "Total affiliates",
  disabled: "Disabled",
  accountConfirmation: "Account Confirmation",
  blocked: "Blocked",
  suspended: "Suspended",
  lastAccess: "Last Access",
  depositBalance: "Deposit Balance",
  bonusBalance: "Bonus Balance",
  dateRegistration: "Registration Date",
  noRegister: "No Registration",
  affiliatedPlayers: "Affiliated Players",
  rowsPerPage: "Rows per page:",
  affiliates: "Affiliates",
  noSearchPerformed: "No search performed",
  changeOddsConfigurationTooltip: "Odds changes settings",
  doNotAcceptOddsChanges: "Do not accept odds changes",
  acceptAboveOddsChanges: "Accept higher odds changes",
  acceptAnyOddsChanges: "Accept any odds changes",
  beCarefulLoginAttemptsTitle: "Be careful",
  beCarefulLoginAttemptsContentAfterRequisition1:
    "You are missing your password too many times. If you continue to miss your password, your account will be blocked.",
  beCarefulLoginAttemptsContentAfterRequisition2:
    "You can recover your password using the button below, or contact support.",
  beCarefulLoginAttemptsContentBeforeRequisition1:
    "You are trying to login with the same password you just tried. If you continue to miss your password, your account will be blocked.",
  beCarefulLoginAttemptsContentBeforeRequisition2:
    "You can recover your password using the button below, or contact support.",
  updatedAt: "Updated at",
  read: "Read",
  notRead: "Not read",
  name: "Name",
  loginCreditBuyer: "Insert the user login to sell credit",
  valueCredit: "Value",
  confirmYourPassword: "Confirm your password",
  confirmYourPasswordDescription:
    "You need to confirm your password to perform this action.",
  noTime: "No time",
  addiction: "Addicted or in risk of becoming",
  dontWantToSay: "Don't want to say",
  instatisfactionOperator: "Insatisfied with the operator",
  instatisfactionBonus: "Insatisfied with the bonus policy",
  other: "Other",
  suspensionReason: "Suspension Reason",
  selectAReasonToSuspend: "Select a suspension reason",
  suspensionReasonDescription: "Insert a short reason for the suspension",
  autoexclusionReason: "Autoexclusion Reason",
  autoexclusionReasonDescription: "Insert a short reason for the autoexclusion",
  unlimited: "Unlimited",
  confirmation: "Confirmation",
  suspendAccount: "Suspend my account til this date",
  autoexcludeAccount: "Autoexclude my account til this date",
  suspendQuestion: "Do you want to suspend your account?",
  autoExcludeQuestion: "Do you want to autoexclude your account?",
  areaForPlayersLogged: "You must log in to suspend the account",
  welcomeMsg: "Welcome to Your Vue.js App",
  selection: "Selection",
  ticket: "Ticket",
  no_selection: "No selection",
  textPhonePreBet: "Fill in your phone to receive the Pre - Bet code via SMS.",
  phone: "Phone",
  phoneOrName: "Phone or name",
  betBonus: "Bet Bônus",
  value: "Price",
  betWithBonus: "Bet with Bonus?",
  possibleGain: "Possible Gain",
  totalOdds: "Total Odds",
  acceptChanges: "Accept changes",
  deposit: "Deposit",
  bet: "Bet",
  preBet: "Pre Bet",
  depositToBet: "Deposit to bet",
  betGreaterthanBonus: `Your bet amount is greater than your available bonus`,
  pleaseLoginAgaing: "Please login again!",
  serverErrorTryAgain: "Server error, try again!",
  playerHasregisterMsg:
    "We identified that you already have a registration with us, to continue login.",
  userFound: "User Found",
  phoneIsMandatory: "Completing the phone number is mandatory!",
  rulesEventsMaxAlert: {
    term1: "Hello, You have the limit of",
    term2:
      " events per bet, please remove some events from the cart to continue.",
    term3: "(Exists",
    term4: "events in cart at the moment.)",
  },
  checkPossibleGainAlert: `You have reached the maximum possible gain`,
  checkBetAmountAlert: "Hi, the minimum bet is",
  maximumMutiplierMsg: "You reached the maximum multiplier",
  noEventsFound: "No events found!",
  loading: "Loading...",
  today: "Today",
  tomorrow: "Tomorrow",
  currentPassword: "Current password",
  infoNewPassword: "Enter a new password",
  consultBet: "Consult Bet",
  allSports: "ALL SPORTS",
  // Agent
  specialLists: "SPECIAL LISTS",
  live: "Live",
  home: "Home",
  searchEvent: "Search Event",
  sports: "Sports",
  knowUs: "Meet Us",
  register: "Sign Up",
  login: "login",
  loginInput: "Login",
  playResponsibly: "Play responsibly.",
  prohibitedForUnder18: "Prohibited for under 18s.",
  partnersAndSponsorships: "Partners and Sponsorships",
  allRightsReserved: "All rights reserved.",
  about: "About",
  nameAndLastName: "Name and last name",
  dateOfBirth: "Date of birth",
  optionalEmail: "Email (Optional) ",
  password: "Password",
  loginOrEmail: "Login/Email",
  confirmPassword: "Confirm Password",
  consultYourAccountText: "Consult your account by SMS.",
  consultYourAccountTextSMS: "Verify your account by SMS.",
  consultYourAccountTextEmail: "Verify your account by Email.",
  weSendAEmail:
    "We will send the code to your registered Email. Confirm your registration to access your account.",
  accountVerificationByEmail:
    "Verify your account by clicking the link sent by Email message.",
  weSendASMS:
    "We will send an SMS to your registered cell phone. Confirm registration to access your account.",
  weSendASMSOrEmail:
    "We will send you an SMS or Email. Confirm your registration to access your account.",
  welcomeToTheNewPlatform: "Welcome to the new platform!",
  setNewPasswordByEmail: "Set your new password by Email.",
  setNewPasswordByClickingLinkEmail:
    "Set your new password by clicking the link sent to your email: ",
  certifyIamOfLegalAge:
    "I certify that I am over 18 years of age and have read and accepted the",
  generalTermsAndConditions: "General Terms and Conditions",
  and: "and",
  agent: "Agent",
  registrationCompleted: "Registration performed!",
  important: "Important!",
  accountVerificationBySMS:
    "Verify your account by clicking the link sent by SMS message.",
  resendEmail: "Resend Email",
  close: "Close",
  hinitLogin: "The login is used to login in your account.",
  loginAsACollaborator: "Sign in as a collaborator",
  registration: "Registration",
  trackYourBets: "Track your Bets",
  accessCredential: "ACCESS CREDENTIAL",
  UseYourPhoneToEnterOurWebsite: "Use your phone number to enter our website.",
  createSecure8DigitPassword:
    "Create a secure 8-digit password with Letters and Numbers.",
  hinitPassword:
    "Introduzca una contraseña de 8 caracteres que contenga letras y números.",
  save: "Save",
  wait: "Wait",
  requiredInput: "This input is required",
  repeatThePassword: "Confirmation must be the same as the password",
  all: "All",
  logingYourPhone: "Login (Your Phone)",
  validPhone: "Enter a valid Phone",
  registrationBeenCompleted:
    "Congratulations, your registration has been completed!",
  required: "Required field",
  max: "You reached the maximum of 50 characters",
  docMax: "You reached the maximum of 50 characters",
  docCPF: "The CPF document must contain 14 characters",
  nameValid: "Enter First and Last Name",
  phoneCounter: "Please enter a valid number (DDD + Number)",
  birthdate: "No children under 18!",
  passMin: "Minimum 8 characters containing letters and numbers",
  passCaracter: "Must have at least letters and numbers",
  validateCPF: "Invalid CPF",
  validEmail: "Please enter a valid email.",
  usernameMax: "Please enter at least 5 characters",
  usernameAz09: "Please enter a valid login",
  emailAlreadyRegistered: "email already registered",
  loginAlreadyRegistered: "Login already registered",
  forgotYourPassword: "Forgot your password?",
  managers: "Managers",
  phoneLinkSMS: "Phone (receive a link via SMS).",
  emailReciveLink: "Email (receive a link by email).",
  loginToStartProcess:
    "Please provide your LOGIN below to begin the password recovery process",
  doLogin: "Login",
  toRecover: "Recover",
  recoveryPassword: "Recover Password",
  portuguese: "Portuguese",
  spanish: "Spanish",
  english: "English",
  // JOBSON - TRADUCAO
  verificationAccount: "Account verification",
  verificationEmail: "Email verification",
  informPassword: "Enter your current password",
  // currentPassword: "Current password",
  oldPassword: "Enter a new password",
  newPassword: "New password",
  rulePassword: "Enter an 8-character password containing letters and numbers",
  // confirmPassword: "Confirm new password",
  // requiredInput: "Repeat the password",
  changePassword: "Change Password",
  digitCodeBet: "Enter the bet code",
  next: "Next",
  cancelBet: "Cancel Bet",
  // close: "Close",
  confirmCancelBet: "Confirm Cancel",
  code: "Code",
  digitPreBet: "Enter the pre-bet code",
  validatePreBet: "Validate pre-bet",
  confirmPreBet: "Confirm validation",
  pendent: "Pending",
  lost: "Lost",
  awarded: "Awarded",
  historic: "Historic",
  sellCredit: "Sell credit",
  search: "Search",
  notFoundBet: "No bets found",
  yes: "Yes",
  no: "No",
  currentBalance: "Current balance",
  limitSales: "Limit sales",
  remainingBalance: "Limit remaining",
  weeekSales: "Weekly sale",
  topClients: "Top clients",
  // unlimited: "Unlimited",
  sales: "Sales",
  commission: "Commission",
  prizesPaid: "Prizes paid",
  balance: "Balance",
  user: "User",
  period: "Period",
  date: "Date",
  qtdSales: "Qtd. sales",
  accurate: "Accurate",
  // cancel: "Cancel",
  prizes: "Prizes",
  deal: "Deal",
  balanceDay: "Balance day",
  balanceFinal: "Balance final",
  grossValue: "Revenues",
  salesCredit: "Sales credit",
  resume: "Resume",
  salesTotal: "Total sales",
  totalCommission: "Total comission",
  totalNet: "Total net",
  active: "Active",
  inactive: "Inactive",
  betCancel: " Canceled",
  betCode: "Bet code ",
  betPlaced: " placed",
  cancel: "Cancel",
  betPaid: " Paid",
  validated: "Validated",
  notValidated: "Not validated",
  betAttencion: "Attention! This action cannot be undone.",
  events: "Events",
  clients: "Clients",
  // value: "Value",
  return: "Return",
  result: "Result",
  // menuTable
  finalResult: "Final Result",
  overUnder: "Goals Over/Under",
  doubleChance: "Double Chance",
  GoalsEuropeanHandicap: "Goals (European Handicap)",
  bothMark: "Both mark",
  oneTwoBoth: "1X2 and Both",
  pointsUnderOver: "Points Over/Under",
  firstPeriodWinner: "1st Period Winner",
  // end menuTable
  paid: "Paid",
  action: "Actions",
  informNewPassword: "Enter a new password below",
  repeatNewPassword: "Repeat new password",
  goHomePage: "Go to the home page",
  reset: "Reset",
  goToWebsite: "Go to website",
  goToSports: "Go to Sports",
  goToCasino: "Go to Casino",
  invitePlayer: "Invite Player",
  exit: "Exit",
  // balance: "Balance",
  // deposit: "Deposit",
  BALANCE: "BALANCE",
  availableToCashout: "AVAILABLE TO CASHOUT",
  restrictBalance: "RESTRICT BALANCE",
  balanceAgent: "BALANCE AGENT",
  BONUS: "BONUS",
  main: "Main",
  specials: "Specials",
  market: "Market",
  possibleReturn: "Possible return",
  allOdds: "Total odds",
  conference: "Conference",
  BETCONFERENCE: "BET CONFERENCE",
  NOVALIDFORAWARD: "(NO VALID FOR AWARD RECEIPT)",
  tournament: "Tournament",
  // action: "Action",
  reverseAmount: "Reverse Amount",
  pendentStatus: "Pendents",
  missed: "Missed",
  reimbursement: "Refund",
  right: "Right",
  carres: "Work with us",
  contact: "Contact Us",
  appClient: "Download App Client",
  appAgent: "Download App Agent",
  help: "Rules",
  regulation: "Regulation",
  terms: "Terms of Use",
  suspend: "Deactivate Your Account",
  responsibleGaming: "Reponsible Gaming",
  privacy: "Privacy Policy",
  bank: "Bank",
  bonus: "Bônus",
  profile: "Profile",
  updateBalance: "Update Balance",
  HowRecoverPassword: "How do you want to recover your password?",

  // MenuNavigationAgent
  homeAgent: "Home Agent",

  //
  // Tradução Daniel
  //
  // BTN's (Padrão)
  BtnCancel: "Cancel",
  BtnSave: "Save",
  BtnNext: "Next",
  BtnDeposit: "Deposit",
  BtnWithdraw: "Withdraw",

  // TAB's (Padrão)
  tabExtract: "Extract",
  tabDeposit: "Deposits",
  tabWithdraw: "Withdraws",

  // =========================================
  // Dashboard USER view: profile.vue - Perfil
  // =========================================

  // TABS
  personalDataTitleTabInfo: "Info",
  personalDataTitleTabSecurity: "Security",

  // Dados Pessoais
  personalDataTitle: "Personal Data",
  personalDataHint: "Find your personal information here.",
  personalDataFullName: "Full Name",
  // (Equivalente ao CPF - fica em aberto)
  personalDataDocument: "Social Security Number",
  personalDataBirthDate: "Birth Date",

  // Dados de Contato
  contactDataTitle: "Contact Details",
  contactDataHint: "Find your contact information here.",
  contactDataPhone: "Phone",
  contactDataEmail: "Email",

  // Dados Financeiros
  financialDataTitle: "Financial Data",
  financialDataHint: "Find your financial information here.",

  // 'Tipo Chave PIX' e 'Chave PIX' ficam em aberto

  // Dados de Endereço
  addressDataTitle: "Address Data",
  addressDataHint: "Find your location information here.",
  addressDataPostal: "Zip-Code",
  addressDataAddress: "Home address",
  addressDataNumber: "Address Nº",
  addressDataDistrict: "District",
  addressDataComplement: "Complement",
  addressDataCityStateTitle: "City - State",

  // Dados de Acesso
  credentialDataTitle: "Access data",
  credentialDataHint: "Find your login information here.",
  credentialDataLogin: "Login",
  credentialDataPassword: "Password",
  credentialChangePassword: "Change Password",

  // Autenticação de duas etapas
  twoStepsAuthTitle: "Two-Step Verification",
  twoStepsAuthHint: "Find your Two-Step Verification information here.",
  twoStepsAuthAlertVerifyPhone:
    "Phone verified | Note: To enable two-step verification, you need to verify your phone.",
  twoStepsAuthBtnVerifyPhone: "Verify my phone",

  // PERFIL - DIALOGS

  // PERSONAL DATA (DADOS PESSOAIS) - dialogEditPersonal.vue
  profileDialogTitle: "Edit Personal Data",
  profileDialogTreatmentTitle: "Title",
  profileDialogFullName: "Name and surname",
  // Equivalente ao CPF
  profileDialogDocument: "Social Security Number",
  profileDialogBirthDate: "Birth Date",
  // BTN's Cancelar e Salvar

  // CONTACT DETAILS (DADOS DE CONTATO) - dialogEditContact.vue
  profileDialogContactTitle: "Contact Details",
  profileDialogContactPhone: "Cell Phone",
  profileDialogContactEmail: "Email",
  profileDialogContactEmailHint: "To edit your email, please contact us.",
  // BTN's Cancelar e Salvar

  // FINANCIAL DATA (DADOS FINANCEIROS) - dialogEditFinancial.vue
  profileDialogFinancialTitle: "Financial Data",
  // Formas de pagamento para o exterior ainda estão indefinidas
  profileDialogFinancialPixKeyType: "Tipo de Chave Pix",
  profileDialogFinancialPhone: "Phone",
  // BTN's Cancelar e Salvar

  // ADDRESS DATA (DADOS DE ENDEREÇO) - dialogEditAddress.vue
  profileDialogAddressTitle: "Location Data",
  profileDialogAddressPostal: "Zip-Code",
  profileDialogAddressHomeAddress: "Home address",
  profileDialogAddressNumber: "Number",
  profileDialogAddressDistrict: "District",
  profileDialogAddressComplement: "Complement",
  profileDialogAddressEstado: "State",
  profileDialogAddressCity: "City",
  // BTN's Cancelar e Salvar

  // ALTERAR SENHA
  // 1º Etapa
  profileDialogEditCredentialtitle: "Change Password",
  profileDialogEditAlert: "To continue enter your current password.",
  profileDialogEditPassword: "Password",

  // 2º Etapa
  profileDialogEditChangePasswordAlert:
    "Set a secure password using letters and numbers.",
  profileDialogEditNewPassword: "New Password",
  profileDialogEditNewPasswordHint:
    "Enter an 8-character password containing letters and numbers.",
  profileDialogEditNewPasswordConfirm: "Confirm Password",
  // BTN's Cancelar e Salvar

  // =========================================
  // Dashboard USER view: bonus.vue - Bônus
  // =========================================

  // INFOS BONUS
  displayBonusValue: "Bonus Value",
  displayeDeadline: "Deadline",
  minimumQuotation: "Minimum Quotation",
  targetValue: "Target Value",
  qualifiedBets: "Qualified Bets",
  bonusReleaseGoal: "Release Goal",

  // (TEXTO) Regra do Bônus
  bonusRuleP1: "Make your first deposit and activate the Bonus offer.",
  bonusRuleP2Part1:
    "After the consolidation of your first deposit, your Betting Bonus of ",
  bonusRuleP2Part2: " of your 1st deposit will be awarded up to $",
  bonusRuleP3:
    "It will only be possible to place bonus bets with a minimum multiplier of ",
  bonusRuleP4:
    "To be able to authorize the Betting Bonus it will be necessary place qualifying bets on the full amount of the Bonus Granted from your deposit, qualifying bets must have minimum quote of ",
  bonusRuleP5:
    "Example: Bonus $20.00. It will be necessary to bet $20.00 on matches with a quotation equal to or greater than the ",
  bonusRuleP6:
    "Your qualifying bet will only count towards the bonus promotion when the matches are finished.",
  bonusRuleP7:
    "After fulfilling the rule, and finishing the matches, the next day the Betting Bonus will be credited to your account as Bonus Value.",
  bonusRuleP8: "Your Betting Bonuses cannot be withdrawn.",
  bonusRuleP9:
    "The user cannot place more than one bonus bet on the same combination: event and bet type.",
  bonusRuleP10:
    "Returns resulting from Bonus Bet amounts will be added to your Available Balance, but Bonus Bet amounts will not be included in any returns.",
  bonusRuleP11:
    "Ex: Bonus Bet of $10.00 with odds of 3.00, If the bet wins, $ ",
  bonusRuleP12: " will be added to your account.",

  // AUTOBONUS

  // REGRAS
  autoBonusTitle: "Rules",
  autoBonusP1: "Make your first deposit and activate the Bonus offer.",
  autoBonusP2Part1:
    "After the consolidation of your first deposit, your Betting Bonus, from",
  autoBonusP2Part2: " % of your 1st deposit up to $",
  autoBonusP3:
    "It will only be possible to place bonus bets with a minimum multiplier of: ",
  autoBonusP4: "Your Betting Bonuses cannot be withdrawn.",
  autoBonusP5:
    "The user cannot place more than one bonus bet on the same combination: event and bet type.",
  autoBonusP6:
    "Returns resulting from Bonus Bet amounts will be added to your Available Balance, but Bonus Bet amounts will not be included in any returns.",
  autoBonusP7: "Ex: When depositing $10.00, $ ",
  autoBonusP8: " will automatically be added to your account.",

  // ==========================================================
  // Dashboard USER view: dashboard/user/bank/index.vue - Banco
  // ==========================================================

  bankBalance: "Balance",
  labelCurrency: "$",
  awardRescue: "Reward Redemption",
  bankHistoric: "Historic",

  // Simple-table
  simpleTableDate: "Date",
  simpleTableId: "ID",
  simpleTableOperation: "Operation",
  simpleTableValue: "Value",

  // ===========================================
  // Dashboard USER view: bankOnline.vue - Banco
  // ===========================================

  // As TABS Extrato - Depósitos - Saques (Padrão) estão no topo deste bloco de tradução

  // Extract Online Datatable
  // extractHeaders
  extractOnlineHeaderDate: "Date",
  extractOnlineHeaderOperation: "Operation",
  extractOnlineHeaderValue: "Value",

  // Deposit Online Datatable
  // DepositHeaders
  depositOnlineHeaderId: "ID",
  depositOnlineHeaderValue: "Value",
  depositOnlineHeaderStatus: "Status",
  depositOnlineHeaderDepositDate: "Deposit Date",
  depositOnlineHeaderDepositQrcode: "QR Code",

  // Withdraw Online Datatable
  // WithdrawHeaders
  withdrawOnlineHeaderId: "ID",
  withdrawOnlineHeaderValue: "Requested Value",
  withdrawOnlineHeaderStatus: "Status",
  withdrawOnlineHeaderKeyType: "Key Type",
  withdrawOnlineHeaderPixKey: "Pix key",
  withdrawOnlineHeaderDateRegister: "Registration Date",

  // Select Label
  selectLabelTranslated: "Status do Depósito",

  // selectItems (Component)
  selectAll: "All",
  selectRequested: "Requested",
  selectConsolidated: "Consolidated",
  selectCanceled: "Canceled",

  // ==========================================
  // Dashboard USER view: list-bet-online.vue - Apostas (Dashboard online)
  // ==========================================

  // Bet Online
  // Headers
  listBetOnlineHeaderId: "ID",
  listBetOnlineHeaderDateHour: "Date/Hour",
  listBetOnlineHeaderEvents: "Events",
  listBetOnlineHeaderAmount: "Value",
  listBetOnlineHeaderPrize: "Financial feedback",
  listBetOnlineHeaderResultBet: "Result",
  listBetOnlineHeaderPaid: "Paid",
  listBetOnlineHeaderAction: "Visualize",

  // Select Label
  selectLabelBetOnlineTranslated: "Award Status",
  // SelectItems
  selectAllbetOnline: "All",
  selectPaidsbetOnline: "Paid",
  selectProcessingbetOnline: "Processing",

  // Search Label
  searchLabelBetonline: "Search",

  // v-chips
  chipIsLive: "Live",
  chipIsBonus: "Bonus",

  // RESUMO DO PERÍODO
  // Resumo Título
  periodSummaryTitle: "Period Summary",
  periodSummaryValue: "Value",
  periodSummaryPrizesPaid: "Paid Awards",
  periodSummaryPossibleAwards: "Possible Awards",
  periodSummaryTotalPrizes: "Total Awards",

  // ==========================================
  // Dashboard USER view: list-bet.vue - Apostas
  // ==========================================

  myBetsTitle: "My Bets",

  // bet_arr.length => apostas
  betArrLengthBets: "bet(s).",
  betFromDate: "From",
  betToDate: "to",

  // list-bet search
  listBetLabelSearch: "Search",

  // Data Iterator - datainterator.vue
  // Alert Msg
  alertDataIteratorMyBets: "No bets found with your filters.",

  // Footer
  MyItemsPerPage: "Items per page:",
  currentPage: "page",
  ofPages: "of",

  // CardBetDataInterator - index.vue (Component)
  cardBetDataPreBetNumber: "No.",
  cardBetDataPreBet: "Pre-bet",
  cardBetDataPreBetEvents: "Events",
  cardBetDataPreBetOdd: "odd",
  cardBetDataPreBetTotalOdds: "Total odds",
  cardBetDataPreBetValue: "Value",
  cardBetDataPrePossibleReturn: "Possible Return",
  cardBetDataPreConference: "Conference",

  // Agent
  enterTheHashCode: "Enter the bet hash code:",
  confirmPayment: "Confirm Payment",
  payBet: "Pay Bet",
  hashCode: "Hash Code",
  validCode: "Enter a valid code",
  statusBetDoesntWin: "Status: Bet does not win.",
  statusBetWonConfirmToPay: "Status: Bet won, confirm to pay.",

  dashboard: "Dashboard",
  overview: "Overview",
  bets: "Bets",
  // historic: "History",
  // validatePreBet: "Validate Prebet",
  payPremium: "Pay Premium",
  // cancelBet: "Cancel bet",
  credit: "Credit",
  // historic: "History",
  financial: "Financial",
  extract: "Extract",
  commissions: "Commissions",
  // bank: "Bank",
  account: "Account",
  // changePassword: "Change Password",
  // =======================================================
  // Dashboard AGENT view: registeredCustomers.vue - Apostas
  // =======================================================

  // Card "Digite o nome do Jogador"
  EnterPlayerNameTitle: "Search Player",
  // Card Placeholder
  EnterNameOrPhone: "Name or phone",

  // Simple-Table
  sumPendent: "Pending",
  sumLost: "Losses",
  sumWin: "Earnings",
  sumComission: "Commission",
  sumBet: "Bets",
  sumNetValue: "Network Value",

  extractByDay: "Statement grouped by day:",
  previousBalance: "Previous balance",

  registeredCustomers: "Registered Customers",
  lastSevenDaysLable: "Last 7 days",
  currentWeekLable: "Current week",
  lastWeekLable: "Last week",
  todayLable: "Today",
  yesterdayLable: "Yesterday",

  // itemsHalfMonth
  lastFifteenDaysLable: "Last 15 days",

  // itemsMonth
  currentMonthLable: "Current Month",
  lasttMonthLable: "Last Month",

  // DATEPICK prefix
  fromDateLable: "From:",
  toDateLable: "To:",

  // DATEPICK locale
  localeDatepickLable: "en",

  // DATEPICK Format
  datePickerStartLable: "MM/DD/YYYY",
  datePickerFinalLable: "MM/DD/YYYY",

  // Select Range
  intervalsLable: "Intervals",

  schedule: "Schedule",
  type: "Type",
  client: "Client",
  printTime: "Print Time",

  theBet: "Bet",
  theBets: "Bets",
  downloadPDF: "Download PDF",
  toPrint: "Print",
  btnCopy: "Copy",
  btnRefresh: "Refresh",

  requested: "Requested",
  authorized: "Authorized",
  consolidated: "Consolidated",
  canceled: "Canceled",
  canceledCampaign: "Canceled",
  tooltipCanceledCampaign:
    "This promotion has been canceled by the platform. The games included can no longer be played through this promotion.",
  expired: "Expired",
  expiredCampaign: "Expired",
  profit: "profit",
  errorOnForm:
    "There are error(s) in the form, please review your information.",

  // dialog-deposit.vue
  depositTitle: "Deposit",
  depositLabel: "Value ($)",
  depositPrefix: "$",
  joinBonus: "DEPOSIT BONUS",
  depositText: `Deposits are made via "payment method". It is mandatory to have an Identification Number registered.`,
  btnPix: "Generate Pix",
  btnDeposit: "Deposit",
  paymentTitle: "Payment",
  paymentText:
    "To make the payment, scan the QR Code in your bank's application or click on the button to copy the code.",
  depositValue: "Deposit amount: $",
  particleOr: "Or",
  iconTitle: "payment method",

  // dialog-withdraw
  withdrawTitle: "Withdraw",
  withdrawText: "After the request, the withdrawal will be sent for analysis.",
  withdrawTax: "Withdraw tax: ",
  btnSend: "Send",
  withdrawLabel: "Value ($)",
  withdrawPrefix: "$",

  maleTitle: "Mr.",
  femaleTitle: "Mrs.",

  ThisFieldIsRequired: "This field is required!",
  repeatPassword: "Repeat password",
  passwordRecover: "Reset password",

  somethingWrong:
    "Something went wrong, if the error persists please contact our support.",
  reviewInformation:
    "There are error(s) in the form, please review your information.",
  brazil: "Brazil",
  southAmerica: "South America",
  europe: "Europe",
  international: "International",
  asia: "Asia",
  oceania: "Oceania",
  africa: "Africa",
  unitedStates: "United States",
  europe2: "Europe 2",
  europe3: "Europe 3",
  southAmerica2: "South America 2",
  middleEast: "Middle East",
  ufcBoxing: "UFC/Boxing",
  liberators: "Liberators",

  // responsibleGaming: "Responsible Gaming",
  accountSuspend: "Account Suspend",
  autoExclude: "Auto-Exclude",
  confirm: "Confirm",
  cantBeUndone: "This action can't be undone!.",
  suspendDescription:
    "If you wish to take a short break from your betting and gaming activity for a short period of time, you can suspend your account for up to six weeks. The suspension of your account still allows you to make withdrawals, but not deposits or bets.",
  autoExcludeDescription:
    "Use self-exclusion if you believe you are at risk of developing a gambling problem or if you believe you currently have a gambling problem. Self-exclusion prevents you from betting with us for a specific period between 6 months and 5 years.",
  open: "Open",
  closed: "Closed",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
  updateSystem: "Updated System.",
  somethingDidntWork:
    "Algo no funcionó correctamente. Actualice su página o, si el problema persiste, comuníquese con nuestro soporte.",
  copyNotification: "Copy Successfully!",
  textRadioConfirmRegister:
    "I want to receive confirmation of registration by:",
  textRadioRecoveryLogin: "I want to receive login recovery for:",
  viewBets: "view bets",
  gain: "gain",
  betAmount: "bet amount",
  reversalAmount: "Reversal amount",
  newPlayer: "Add new player",
  rewardRedemption: "Reward Redemption",

  breaks: "Breaks",
  invalidTime: "Invalid time",
  weeklyCalculation: "Weekly Calculation",
  currentCalculation: "Current Calculation",
  from: "From",
  until: "Until",

  show: "Mostrar",
  sum: "Sum",
  nullData: "No data found in the selected period.",
  formRegisterTitlePersonalData: "Personal Data",
  formRegisterTitleAccessCredential: "Access Credential",

  indicatedBy: "Indicated by",
  recoverLoginMsg:
    "Enter your CPF below and we'll send you a message containing your login.",
  recoverLoginBtn: "Recover Login",
  interval: "Interval",
  filters: "Filters",
  toClean: "Clean",
  toFilter: "Filter",
  searchByName: "Search by name",
  searchPlayers: "Search Players",
  paybet: "Pay Bet",
  periodSummaryPrizesToPaid: "Prizes payable",
  simple: "Simple",
  double: "Double",
  triple: "Triple",
  multiple: "Multiple",
  firstHalf: "1st Half",
  firstHalfExtension: "1st Half Extension",
  secondHalf: "2nd Half",
  secondHalfExtension: "2nd Half Extension",
  sanctions: "Sanctions",
  break: "Break",
  totalTime: "Total Time",
  fullPeriodAfterOvertime: "Full Period After Overtime",
  fullPeriodAfterPenalties: "Full Period After Penalties",
  matchNotStarted: "Match not Started",
  firstQuarter: "1st Quarter",
  secondQuarter: "2nd Quarter",
  thirdQuarter: "3rd Quarter",
  fourthQuarter: "4th Quarter",
  overtime: "Overtime",
  firstMap: "1st Map",
  secondMap: "2nd Map",
  thirdMap: "3rd Map",
  fourthMap: "4th Map",
  fifthMap: "5th Map",
  endOfMatch: "End of Match",
  firstSet: "1st Set",
  secondSet: "2nd Set",
  thirdSet: "3rd Set",
  fourthSet: "4th Set",
  fifthSet: "5th Set",
  goldenSet: "Tie Break",
  firstInning: "1st Inning",
  secondInning: "2nd Inning",
  thirdInning: "3rd Inning",
  fourthInning: "4th Inning",
  fifthInning: "5th Inning",
  sixtyInning: "6th Inning",
  seventhInning: "7th Inning",
  eighthInning: "8th Inning",
  ninthInning: "9th Inning",
  extraInning: "Extra Innings",
  firstRound: "1st Round",
  secondRound: "2nd Round",
  thirdRound: "3rd Round",
  fourthRound: "4th Round",
  fifthRound: "5th Round",
  sixtyRound: "6th Round",
  seventhRound: "7th Round",
  eighthRound: "8th Round",
  ninthRound: "9th Round",
  tenthRound: "10th Round",
  eleventhRound: "11th Round",
  twelfthRound: "12th Round",
  current_balance: "Current Balance",
  previous_balance: "Previous Balance",
  amlPolicy: "AML Policy",
  betMinimum: "Minimum Bet",
  betMaximum: "Maximum Bet",
  activiteMinutes: "Activity Minutes",
  minimumDeposit: "Minimum Deposit",
  maximumDeposit: "Maximum Deposit",
  depositInterval: "Deposit Interval",
  depositLimitValue: "Deposit Limit Value",
  userLimitsSubtitle: "Find Bet, Deposit and Activity limits here",
  userLimits: "User Limits",
  useTimeLimits: "Use Time Limits",
  depositLimits: "Deposit Limits",
  bettingLimits: "Betting Limits",
  editLimits: "Edit Limits",
  depositLimitValues: "Deposit Limit Values",
  depositTimeLimit: "Deposit Time Limit",
  twentyFourHours: "24 hours",
  fortyEightHours: "48 hours",
  sevenDays: "7 days",
  thirtyDays: "30 days",
  twentyMinutes: "30 Minutes",
  sixtyMinutes: "60 Minutes",
  ninetyMinutes: "90 Minutes",
  oneHundredTwentyMinutes: "120 Minutes",
  noLimits: "No Limits",
  noLimitBet: "No Limit Bet",
  noActivityLimit: "No Activity Limit",
  noDepositLimit: "No Deposit Limit",
  noDepositTimeLimit: "No Deposit Time Limit",
  youUsedTheSiteFor: "You used the site for",
  doYouWantToContinueBrowsing: "minutes. Do you want to continue browsing?",
  continue: "Continue",
  timeOfUseController: "Time of Use Controller",
  messages: "Messages",
  description: "Description",
  noNewMessagesAtMoment: "You currently have no new messages",
  message: "Message",
  validatePromotion: "Validate Promotion",
  bonusAndPromotions: "Bonus and Promotions",
  promotionCode: "Promotion Code",
  registerPromotionalCode: "Register promotional code",
  firstDepositBonus: "First Deposit Bonus",
  promotionRules1: "A promotion coupon can only be redeemed once per user.",
  promotionRules2:
    "Promotional coupons can be closed at any time, they have a start and end date, and even within the redemption period, it may have a limitation on the number of people who can redeem it.",
  sendThePromotionCodeHere: "Send the promotion code here:",
  rulesAndConditionsOfPromotions: "Promotions Rules and Conditions",
  validate: "Validate",
  invalid: "Invalid",
  addPunter: "Add Punter",
  namePlayer: "Player Name",
  doYouWantToRemoveInvalidEvents: "Do you want to remove invalid events?",
  accomplish: "Accomplish",
  new: "NEW",
  afterPerformingThe: "After performing the",
  betSendTheNewIDtoPunter: " bet, send the new identifier (ID) to the Punter",
  thereAreNoValidEventsForThisTicket:
    "There are no valid events for this ticket",
  placeNewBet: "Place NEW bet",
  checkInvalidBets: "Check invalid bets",
  textBet: "Bet",
  gameName: "Game Name",
  bonusRuleP13:
    "To make a withdrawal, you must have made at least one deposit.",
  autoBonusP9: "To make a withdrawal, you must have made at least one deposit.",
  multiplier: "Multiplier",
  cashOut: "Cash Out",
  noBetsFound: "No bets found",
  pending: "Pending",
  resolved: "Resolved",
  closeBet: "Close",
  casino: "Casino",
  videoSlots: "Video Slots",
  liveCasino: "Live Casino",
  scratch: "Scratch Games",
  tableGames: "Table Games",
  comingSoon: "Coming soon",
  toPlayInTheCasinoRegistorOrLogin: "To play in the Casino, Register or Login.",
  play: "Play",
  playNow: "Play now",
  funPlay: "Fun Play",
  onMaintenance: "Website under maintenance",
  onMaintenanceMessage:
    "To better serve you, we are under maintenance. Please try again later.",
  roulette: "Roulette",
  unauthorizedLiveStream: "You must be logged in to access Live Stream.",
  unavailableTracker: "Tracker unavailable for this event",
  shareCoupon: "Share my Ticket",
  placeYourBet: "Place your bet",
  bettingTicket: "Betting Ticket",
  expiredEvents: "Expired Events",
  expiredEventsDetail: "These events have expired: ",
  yesContinue: "Continue anyway",
  cleanCart: "Clean Cart",
  viewInCasaDeApostas: "View in Casa das Apostas",
  pendingWithdraw: "Pending",
  cancelWithdraw: "Cancel Withdraw",
  cancelWithdrawExplanation:
    "This withdrawal is pending. If you request cancellation, the requested amount will be added to your balance.",
  game: "Game",
  wallet: "Wallet Pay4Fun",
  myPromotions: "My Promotions",
  promotions: "Promotions",
  promotionMaxBonus: "$ {max_bonus} in Bonus",
  noPromotionForYou: "There are no promotions available.",
  progressTooltip: "You still need to bet $ {betValueLeft}.",
  noActivePromotion: "You have no active promotion.",
  useCode: "Use Code",
  rolloverProgressDescription:
    "You can track your bonus progress. Upon completing the rollover, you will be able to transfer your bonus balance to your balance!",
  rolloverBetValue: "Bet Value",
  progress: "Promotion Progress",
  transferBalance: "Transfer Balance",
  rolloverPercentageMissing: "{percentageMissing}% Missing",
  rolloverCompleted: "Rollover Completed",
  goBack: "Go Back",
  joinPromotion: "Adhere Promotion",
  knowMore: "Know More",
  totalRollover: "Total Rollover",
  bonusGained: "Gained Bonus",
  activePromotions: "Active Promotions",
  transformYourBonusIntoMoney: "Turn your bonus into cash:",
  expiresIn: "Expires in",
  expiredIn: "Expired in:",
  transfer: "Transfer",
  promoCode: "Promo Code (Optional)",
  promoCodeWithoutOptional: "Join Promotion",
  theDeposit: "the deposit",
  theAdmission: "the admission",
  attention: "Warning",
  when: "When",
  promotionIsConfirmedDeposit:
    "is confirmed, your bonus balance will be reseted and a new rollover process will be started.",
  promotionIsConfirmedOther:
    "is confirmed, your bonus balance will be reseted and a new rollover process will be started.",
  ifYouContinueAnd: "If you continue and",
  currentlyYouGotThisPromotion: "Currently you got this active promotion:",
  isConfirmedThisWillBeYourNewPromotionDeposit:
    "is confirmed, this will be your new promotion:",
  isConfirmedThisWillBeYourNewPromotionOther:
    "is confirmed, this will be your new promotion:",
  promotionalCodes: "Promotional Codes",
  promotionHistory: "Promotion History",
  noPromotionHistory: "There are no previous promotions.",
  finishedPromotion: "Finished",
  promotionDetail: "Promotion Detail",
  seeDetail: "See Detail",
  nextBalance: "Subsequent Balance",
  operationName: "Operation Name",
  promotionUseDetail: "Promotion Usage Details",
  actions: "Actions",
  seeRules: "See Rules",
  promotionRules: "Promotion Rules",
  afterTransfer:
    "After the transfer, the promotion will end, and if there is any remaining balance, the amount will be lost.",
  afterTransferAnotherDialog: "After the transfer, the promotion will end.",
  howItWorks: "How It Works",
  none: "None",
  firstDepositPromotion: "1st Deposit",
  depositPromotion: "Deposit",
  promotionBetsAfterTransfer:
    "If any bets related to this promotion are still pending, they will no longer be valid.",
  gamingType: "Gaming Type",
  totalAwards: "Total Awards",
  totalComission: "Total Comission",
  casinoAndBetting: "Casino and Betting",
  sportsBetting: "Sports Betting",
  noGamesFoundWhileSearching: "No games found. Try adjusting your search term.",
  noGamesFound: "No games found.",
  doingLogin: "Logging In",
  brazilCashFooter:
    "Brasil Cash is a fast and secure way to make your deposits by PIX. After payment, the balance will be credited instantly!",
  brasilCashFooter2:
    "Brasil Cash is a company that provides its own technology services as a payment institution and sub-accreditor, including through POS (card machine).",
  pixlancecertoFooter:
    "LanceWallet is a fast and secure way to make your deposits by PIX. After payment, the balance will be credited instantly!",
  startingSoon: "Starts in {minutes} minutes",
  clientGains: "Client receives",
  verification: {
    pageName: "Verify",
    document: {
      name: "Identity Verification",
      description: `
      Please send your identity document and a clear photo of the
      his face. All documents must be on a flat surface with
      the 4 corners inside the frame. All information must be clear and
      identifiable.
      `,
      acceptedDocuments: "Documents accepted for verification:",
      alert:
        "All data is encrypted and securely stored. <br /> Once edited, your data cannot be changed.",
      possibleDocuments: {
        passport: "Passaport",
        driversLicense: "Driver License",
        identity: "Identity Card with CPF",
        workCard: "Work Card with CPF",
      },
      inputs: {
        documentFront: "Proof of Identity (Front)",
        documentVerse: "Proof of Identity (Back)",
        faceBiometry: "Face Picture",
      },
      denied: {
        someMotives:
          "The disapproval of document verification may have been due to some factors, such as:",
        motive1:
          "Erased, crumpled, illegible documents, that is, outside the acceptance standards.",
        motive2: "Third party documents.",
        motive3: "Non-compatible photos, blurry, without adequate lighting.",
        motive4: "Image background full of information.",
        doubts:
          "You can try to contact our support if there are any doubts. We're sorry, but your verification was declined.",
      },
      alertMessage: {
        inProgress:
          "Your documents have already been sent, please wait while we process validation.",
        finished:
          "All very well! You have successfully had your documentation verified.",
        denied:
          "Your documentation was not approved, some reasons may have influenced.",
      },
      allowedTypes: "The following file types are accepted: .png, .jpg, .pdf",
      sizeError: "The image is larger than 900KB",
      minWidth: "The minimum width for the document image is 1000px",
      sizeSumError: "The sum of the image sizes can not be larger than 2.2MB.",
      faceBiometryMinWidth: "The minimum width for the face picture is 250px.",
      faceBiometryMinHeight:
        "The minimum height for the face picture is 250px.",
      documentNotVertical: "The image must not be vertical or tilted.",
      nothingSelected: "No file selected",
      filesDetail:
        "Identity proof photos must be sent in landscape format (horizontal) and must be at least 1000 pixels wide. The face photo must be clear, with a minimum resolution of 250x250 pixels.",
      fileImgSame: "Send a IMAGE file the same as the Front document",
    },
    bank: {
      name: "Bank Verification",
      description: "Your pix key must belong to one of the authorized banks:",
      alert: {
        success: "Bank verification completed successfully.",
        inProgress: "Bank verification is in progress. Please wait a moment.",
      },
    },
    email: {
      name: "Email",
      btnResendVerify: "Resend verification email",
      descriptionVerify: {
        text1:
          "When you confirm your email, you will receive exclusive promotions from our platform!",
        text2:
          "In addition, your user will be recognized in our system and our support team ",
        text3: "will always be available if necessary.",
      },
      tipVerify: {
        title: "Tips:",
        tip1: "When requesting resend email, always check the last email sent!",
        tip2: "Verify your account by clicking on the link sent by email.",
        tip3: "Remember to check your junk and/or spam folder!",
        tip4:
          "If you haven't received it, you can request another one after 1 minute.",
      },
      successMessage: "Your account has been verified! Happy betting!",
    },
    phone: {
      name: "Phone",
      btnVerify: "Send code",
      descriptionSecurityVerify: {
        text1:
          "Verify your phone number to ensure the security of your account.",
        text2:
          "Also, when verifying, you can enable or disable <strong>Two-Step Verification</strong> under Profile, Security.",
      },
      descriptionPhoneVerify: {
        title: "<strong>How do I check my phone?</strong>",
        text1:
          "Click Send code, then you will receive a code via SMS on your registered phone.",
        text2: "Enter the code in the fields and wait.",
        text3:
          "If you do not receive the code or it expires, request a new one.",
      },
      successMessage: "Your phone has been verified successfully!",
    },
    status: {
      actionNeeded: "Action Needed",
      pendent: "Pendent",
      finished: "Finished",
      inProgress: "In Progress",
      denied: "Denied",
    },
  },
  finalWinner: "Final Winner",
  winner: "Winner",
  verificationAlertMessage:
    "There are one or more pending checks. Make the necessary checks to carry out withdrawals.",
  affiliatesPayments: {
    linkPlayer: "Link Player",
    transfers: "Transfers",
    invoiceEmission: "Invoice Emission",
    insertPlayerAccount:
      "Enter your login and password for your player account that will receive payments.",
    linkedPlayer: "Linked Player",
    successLink: "Successfully linked player account.",
    infoLink:
      "Link a player account. You will receive your commission payment there.",
    linkError:
      "An error occurred while trying to find linked account information.",
    paymentReferringMonth: "Payments referring to",
  },
  casinoBetting: {
    setDateRange: "You need to set the date range.",
    loadingBets: "Loading bets...",
    bet: "Bet",
    bets: "Bets",
    prize: "Prize",
    prizes: "Prizes",
    betRefund: "Bet Refund",
    betsRefund: "Bets Refund",
    prizeRefund: "Prize Refund",
    prizesRefund: "Prizes Refund",
    freespinPrize: "Freespins Prize",
    profit: "Profit",
    allGames: "all games",
    date: {
      last24Hours: "Last 24 hours",
      last48Hours: "Last 48 hours",
      last7Days: "Last 7 days",
      dateInterval: "Date interval",
    },
    headers: {
      dateAndHour: "Date and hour",
      transactionId: "Transaction ID",
      roundId: "Round ID",
    },
  },
  newCasino: {
    unloggedAtGame:
      "To play <b>{game}</b> and much more, do login or create your account.",
    showingGamesProgress: "Showing {current} of {total} games",
    loadMore: "Load More",
    pageTitle: {
      providers: "Casino Game Providers",
      provider: "{provider}",
      category: "{category} ",
      game: "{game}",
    },
    providers: "Providers",
    games: "Games",
    gamesFavorites: "Favorites games",
    btnFavorite: "Favorite | Favorite",
    relatedGames: "Related Games",
    noProvidersFound: "No providers found.",
    noCategoriesFound: "No categories found.",
    noGamesFoundLobby: "No games found.",
    thisMasculine: "this",
    thisFeminine: "this",
    withFilters: " with these filters.",
    noGamesFound: "No games were found for {thisPronoun} {model}{withFilters}",
    noGamesFoundFavorite: "You haven't added any games to your favorites yet.",
    category: "category",
    categories: "Categories",
    provider: "provider",
    others: "others",
    orderBy: "Order by",
    volatility: {
      name: "Volatility",
      tooltip: `Volatility is provided by game providers.
      This is used to indicate to players how often
      how the slot assigns payouts, and how high they might
      wait for the payments.`,
      high: "High",
      "very-high": "Very high",
      "medium-high": "Medium-high",
      medium: "Medium",
      "low-medium": "Medium-low",
      low: "Low",
    },
    rtp: {
      tooltip: `RTP: The return to player, or RTP, in any game,
      is the expected percentage of bet amounts that
      a specific game will return to the player over the course of
      a period of time.`,
    },
    search: {
      inputLabel: "What do you want to play?",
      recentSearches: "Recent searches",
      noRecentSearches: "No recent searches",
      searchFavoritesGames: "Search here for your favorite games!",
      removeAllSearches: "Clean all",
      gameNotFound: "Game not found",
      verifySearchTerm:
        "Make sure the name is correct or look for another keyword.",
      toPlayDo: "To play the game,",
      createAnAccount: "create an account",
    },
    freespins: {
      detail: "Details",
      expiresIn: "Expires in {hour}h and {minute}m",
      gainFreeRounds: "Gain free rounds!",
      claimDate: "Claim date",
      rules: {
        titleDialogDepositCampaign: "Campaign Rules",
        first:
          "1. Participation in the campaign indicates full acceptance of its terms and conditions.",
        second:
          "2. The bonus is only valid for customers registered on the site who claim the freespin campaign until the expiry date.",
        third:
          "3. The bonus is only valid for the games contained in the campaign.",
        fourth:
          "4. To take advantage of the promotion, after activating the campaign, go to the Active Promotions menu and click on Play.",
        fifth:
          "5. This promotion can generate a rollover up to 100x.",
        sixth: "6. Have fun with your freespins!",
      },
      noCampaignFoundForGame: "No campaigns found for the searched game.",
      roundsClaimed: "Rounds claimed",
      roundsQuantity: "Rounds quantity",
      noCampaignsAvailable: "No freespins campaigns currently available.",
    },
  },
  firstPasswordRegistration: {
    rules: {
      description: "Your password must meet these requirements:",
      oneUppercaseLetter: "At least one uppercase letter is required",
      oneLowercaseLetter: "At least one lowercase letter is required",
      oneLowerAndUppercaseLetter:
        "At least one uppercase and one lowercase letter is required",
      oneSpecialCharacter:
        "At least one special character is required (#?!@$%^&*-)",
      oneNumber: "At least one number is required",
      eightCharacters: "Password must be exactly 8 characters",
      confirmation: "Password and confirmation must match",
      betweenEightAndTwelveCharacters:
        "The password must be between 8 and 12 characters",
    },
  },
  fullscreen: "Fullscreen",
  goToMyPromotions: "Go to My Promotions",
  newRegister: {
    registerToBet: "Register to bet!",
    welcome:
      "<strong>Welcome to our platform, {playerName}! &#127881;</strong>",
    infoLoginAndSupport:
      "Your login will be done using the same email address used during registration. If you have any questions, we will be happy to help.",
    makeYourDeposit: "Make your first deposit and happy betting! &#128526;",
    agreeAdulthood:
      "By registering, you agree that you are at least 18 years of age and accept the ",
    andThe: " and the ",
    emailsDontMatch: "Emails do not match",
    emailLabel: "Email (enter a valid email",
    emailLabelTooltip: "This email will be used as your account login.",
  },
  confirmEmail: "Check my email",
  verifyEmailBeforeWithdraw: "To withdraw, you need to verify your email.",
  verifySmsToken: {
    phoneVerification: "Verify your phone",
    twoStepsAuthentication: "Two-step verification",
    insertTokenHere:
      "A code has been sent to your registered cell phone. <br /> Insert it here.",
    invalidToken: "Invalid code",
    resendToken: "Resend code",
    resendTokenTimer: "Resend code ({seconds} sec)",
    deactivateTwoStepsAuthentication:
      "You can disable this verification in Profile > Security",
    recommendActivateTwoStepsAuthentication:
      "Click here to enable two-step verification when logging in (we recommend to ensure the security of your account)",
  },
  noDataText: "No data",
  noResultsText: "There is no data for this search",
  changeContactInfo: {
    emailAction: "Email change confirmation",
    phoneAction: "Phone change confirmation",
    loginChangeAfterEmailChange:
      "When you modify your email, your login will be changed to the new email.",
  },
};
export default en;
